function initHeroSwipers() {
  if (!window.Swiper) return;

  document.querySelectorAll('.hero-swiper:not([data-swiper-ready])').forEach((el) => {
    el.setAttribute('data-swiper-ready', 'true');

    const delay = parseInt(el.dataset.autoplayDelay, 10) || 3000;

    // Reference site (comicsense.store) uses a flat slidesPerView: 3.2 on desktop, but that
    // only works there because it has 14 real slides. Swiper requires
    // realSlideCount >= ceil(slidesPerView) + slidesPerGroup + loopAdditionalSlides to keep
    // loop mode enabled, so on our 4-slide carousels (acrylic posters, lamps, phone cases,
    // keychains) 3.2 would silently disable looping again. Cap per-instance at the real
    // slide count minus 1 so every carousel gets as close to the reference 3.2 as it can
    // safely support - the 7-slide homepage gets the exact match, the 4-slide ones get 3.
    const realSlideCount = el.querySelectorAll('.swiper-slide').length;
    const desktopSlidesPerView = Math.min(3.065, realSlideCount - 1);

    new window.Swiper(el, {
      loop: true,
      slidesPerView: 1.06,
      spaceBetween: 5,
      speed: 400,
      autoplay: {
        delay,
        disableOnInteraction: false,
        // Reference site (comicsense.store) keeps sliding even while the cursor is
        // hovering a slide - matches that instead of the usual pause-on-hover default.
        pauseOnMouseEnter: false,
      },
      navigation: {
        nextEl: el.querySelector('.hero-swiper-arrow--next'),
        prevEl: el.querySelector('.hero-swiper-arrow--prev'),
      },
      breakpoints: {
        690: { slidesPerView: desktopSlidesPerView, spaceBetween: 5 },
      },
    });
  });
}

if (window.Swiper) {
  initHeroSwipers();
} else {
  // The Swiper CDN <script> tag loads synchronously right before this file, so this
  // is only a defensive fallback for the rare case that ordering assumption breaks.
  let attempts = 0;
  const retry = setInterval(() => {
    attempts += 1;
    if (window.Swiper || attempts > 20) {
      clearInterval(retry);
      initHeroSwipers();
    }
  }, 100);
}
